import { useMemo } from 'react'
import cn from 'classnames'
import { LearningToolkitRemovalExperiment } from 'experiments/pen-5590_v1_global_learning_toolkit_removal_whats_in_a_membership'
import { Icon } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import styles from './Subscription.module.scss'

export const ValuePropsList = () => {
  const { t } = useTranslation('@mc/next')

  const list = useMemo(
    () => [
      {
        icon: 'lessons',
        text: t('subscription.info.allClassesWithSeries', {
          instructors: getNumberOfInstructors(),
        }),
      },
      {
        icon: 'unmuted',
        text: t('subscription.info.audio'),
      },
      {
        icon: 'download',
        text: t('subscription.info.offline'),
      },
      {
        icon: 'list',
        text: t('subscription.info.workbooks'),
      },
      {
        icon: 'lessons',
        text: t('subscription.info.devices'),
      },
      {
        icon: 'star',
        text: t('subscription.info.newClasses'),
      },
      {
        icon: 'check',
        text: t('subscription.info.moneyBack'),
      },
    ],
    [t],
  )

  return (
    <ul className='mc-overflow--hidden'>
      <LearningToolkitRemovalExperiment
        control={() =>
          list.map(({ icon, text }) => (
            <li key={text} className={cn(styles.item, 'd-flex', 'mc-my-3')}>
              <div>
                <Icon
                  kind={icon}
                  className='mc-icon--3 mc-opacity--hinted mc-mr-3'
                />
              </div>
              {text}
            </li>
          ))
        }
      />
    </ul>
  )
}
